











































































import Vue from 'vue'
import PasswordResetForm from '@/components/PasswordResetForm.vue'
import InvitationsAcceptForm from '@/components/InvitationsAcceptForm.vue'
import User from '@/types/User.interface'
import mixin from '@/mixins/tenant-nav-mixin'
export default Vue.extend({
    components: { InvitationsAcceptForm, PasswordResetForm },
    mixins: [mixin],
    data() {
        return {
            //  Determines if invitation is invalid
            invalid: null,
            //  Styles for our elements at the foot of the page
            footerStyle: {
                position: 'absolute',
                left: 0,
                right: 0,
                margin: 'auto',
                display: 'block'
            },
            newUser: {
                email: null,
                firstname: null,
                fullname: null,
                lastname: null,
                mobilephone: null,
                password: null,
                terms_accepted: null
            },
            //  Condition that holds if this user exists already
            userExists: null,
            //  Condition that checks when form has been submitted
            userUpdated: null
        }
    },
    mounted() {
        const invalid = this.$route.query.invalid
        if (invalid) return (this.invalid = true)

        //  Save user details from query params
        const user_exists = this.$route.query.userExists
        const firstname = this.$route.query.firstName || ''
        const lastname = this.$route.query.lastName || ''
        const phone = this.$route.query.phone || ''

        //  If user exists
        if (user_exists) {
            //  Set userExists to true
            this.userExists = true

            //  Set user data from query params to newUser data variable
            this.newUser.fullname = firstname + ' ' + lastname
            this.newUser.mobilephone = this.$options.filters.phone(phone)
        }

        //  Grab our email query
        const email = this.$route.query.email

        //  Attach this email to our user
        this.newUser.email = email
    },
    beforeRouteLeave(to, from, next) {
        //  If routing to sign in and user has not been updates, don't route
        if (to.path == '/signin' && !this.userUpdated) return

        //  Else, proceed to next route
        next()
    },
    computed: {
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        onUserUpdate(): void {
            this.userUpdated = true

            if (this.userExists) return this.$router.push('/memberships')

            //  Check if mobilephone is verified
            const phoneVerified = this.user.mobilephone_verified

            //  If their mobile phone is not verified then navigate to the verify sms page
            if (!phoneVerified)
                return this.$router.push(
                    '/register/verifysms?goto=/home&popNewUserWelcome=true'
                )
        }
    }
})
